import { UPDATE } from '../../constants/storeOpeningHours.constants';
import { createLoadingSelector } from '../../selectors/loading.selector';

export const getIsUpdating = createLoadingSelector([UPDATE]);
